import dayjs from 'dayjs';
import React from 'react';

import style from './ManageWaitlistDatePicker.style';
import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable';

const ManageWaitlistDatePicker = ({ interviewDates = [], setSelectedDate, selectedDate, setShowDatePicker }) => {
  const headerFormatter = (column, colIndex) => {
    return <div style={style.headerStyle}>{column.text}</div>;
  };

  const cellFormatter = (cell, data) => {
    const {
      row,
      column,
      DateOfInterview,
      CountOfCandidates,
      NumberOfWaitlistedCandidates,
      CandidateRegistrationLimit,
      Label,
    } = data;

    switch (column.label) {
      case 'Interview Date':
        return (
          <div style={{ ...style.cellStyle }}>
            <div>
              <div style={style.centeredText}>
                {DateOfInterview ? dayjs(DateOfInterview).format('dddd, MMMM DD, YYYY') : ''}
              </div>
              <div style={{ ...style.centeredText, fontSize: 12 }}>{Label ? Label : ''}</div>
            </div>
          </div>
        );
      case 'Registered':
        return <div style={style.cellStyle}>{CountOfCandidates || 0}</div>;
      case 'Waitlisted':
        return <div style={style.cellStyle}>{NumberOfWaitlistedCandidates || 0}</div>;
      default:
        return <div style={style.cellStyle}>{CandidateRegistrationLimit || 0}</div>;
    }
  };

  const makeColumns = () => {
    const newColumns = [];
    const headers = [
      { text: 'Interview Date', dataField: 'DateOfInterview', width: '60%' },
      { text: 'Registered', dataField: 'CandidateRegistrationLimit' },
      { text: 'Slots', dataField: 'CandidateRegistrationLimit' },
      { text: 'Waitlisted', dataField: 'CandidateRegistrationLimit' },
    ];
    headers.forEach((header) => {
      newColumns.push({
        dataField: header.dataField,
        text: header.text,
        label: header.text,
        width: header.width,
        formatter: cellFormatter,
        headerFormatter: headerFormatter,
        style: (data) => {
          const { row } = data;

          const backgroundColor =
            selectedDate && selectedDate.pk_InterviewDate === row.pk_InterviewDate ? 'var(--rr-primary-soft)' : null;
          return { verticalAlign: 'middle', width: header.width || 'auto', backgroundColor, cursor: 'pointer' };
        },
        headerStyle: { verticalAlign: 'middle' },
        formatExtraData: { label: header.text },
        events: {
          onClick: (data) => {
            const { cell, row, rowIndex, colIndex } = data;
            setSelectedDate(row);
            setShowDatePicker(false);
          },
        },
        headerEvents: {
          onClick: (e, column, columnIndex) => {},
        },
        headerAttrs: {
          // id: 'timeSlotHeader',
        },
        attrs: (cell, row, rowIndex, colIndex) => {
          // return { id: `timeSlot_${row.pk_Timeslot}` };
        },
      });
    });

    return newColumns;
  };

  const columns = makeColumns();

  return (
    <div style={{ height: '100%', overflowY: 'scroll' }}>
      {/* <BootstrapTable
        bordered={false}
        columns={makeColumns()}
        data={interviewDates || []}
        keyField="pk_InterviewDate"
      /> */}
      {/* <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} style={{ minWidth: column.minWidth }}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            const rowProps = row.getRowProps();
            // Apply the sticky row style conditionally
            if (i >= interviewDates.length - 1 || interviewDates.length === 1) {
              rowProps.style = { position: 'sticky', bottom: -2, backgroundColor: 'white' };
            }
            return (
              <tr {...rowProps}>
                {row.cells.map((cell) => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table> */}
      <RezRateTable columns={columns} data={interviewDates || []} tableBodyHeight={350} keyField="pk_InterviewDate" />
    </div>
  );
};

export default ManageWaitlistDatePicker;
